export const SET_DEBTOR = "WAGE_DEBTORS/SET_DEBTOR";
export const SET_WAGE_SCHEDULE = "WAGE_DEBTORS/SET_WAGE_SCHEDULE";
export const SET_WAGE_DEDUCTION_AUTHORIZATION_DATA =
  "WAGE_DEBTORS/SET_WAGE_DEDUCTION_AUTHORIZATION_DATA";
export const CLEAR_WAGE_DEDUCTION_AUTHORIZATION =
  "WAGE_DEBTORS/CLEAR_WAGE_DEDUCTION_AUTHORIZATION";

export const setWageDeductionAuthorization = ({
  wageDeductionAuthorization,
  stewardRequestSignatureURL,
  clientRequestSignatureURL,
}) => {
  return {
    type: SET_WAGE_DEDUCTION_AUTHORIZATION_DATA,
    wageDeductionAuthorization,
    stewardRequestSignatureURL,
    clientRequestSignatureURL,
  };
};

export const clearWageDeductionAuthorization = () => {
  return {
    type: CLEAR_WAGE_DEDUCTION_AUTHORIZATION,
  };
};

export const setDebtor = debtor => {
  return {
    type: SET_DEBTOR,
    debtor,
  };
};

export const setWageSchedule = wageSchedule => {
  return {
    type: SET_WAGE_SCHEDULE,
    wageSchedule,
  };
};
